import {
  Resource_AppointmentTaskDueStage,
  Resource_AppointmentTaskType,
} from '@/generated/graphql';

export default {
  'appointment-tasks': 'Terminaufgaben',
  'appointment-tasks.task-completed': 'Aufgabe abgeschlossen!',
  'appointment-tasks.title-unknown': '<Unbenannt>',
  'appointment-tasks.reason-for-cancellation': 'Grund für die Stornierung: {reasons}',
  'appointment-tasks.reason-for-cancellation.missing': 'Keine Begründung angegeben',

  'appointment-tasks.info.empty': 'Keine weiteren Informationen vorhanden.',
  'appointment-tasks.info.mark-as-read': 'Als gelesen markieren',
  'appointment-tasks.info.marked-as-read': 'Gelesen',

  'appointment-task.document-upload': 'Dateiupload',
  'appointment-task.document-upload.not-available': 'Dokument nicht vorhanden',
  'appointment-task.document-upload.not-available.done': 'Als nicht vorhanden markiert',
  'appointment-task.document-upload.not-available.confirm': 'Dieses Dokument liegt Ihnen nicht vor? Die Praxis wird darüber informiert.',
  'appointment-task.document-upload.complete': 'Abgeschlossen',
  'appointment-task.document-upload.dragger.title': 'Datei hochladen',
  'appointment-task.document-upload.dragger.title.edit': 'Andere Datei hochladen',

  'appointment-task.document-download.description':
    'Es steht ein Dokument zum Download für Sie zur Verfügung.',
  'appointment-task.document-download.download': 'Dokument herunterladen',
  'appointment-task.document-download.download-again': 'Nochmals herunterladen',

  'appointment-task.form.start-form': 'Fragebogen ausfüllen',
  'appointment-task.form.continue-form': 'Fragebogen fortfahren',
  'appointment-task.form.form-completed': 'Fragebogen ausgefüllt',

  'appointment-task.type.title.not-present': 'Titel nicht vorhanden',

  [Resource_AppointmentTaskType.AppointmentTaskTypeForm]: 'Formular ausfüllen',
  [Resource_AppointmentTaskType.AppointmentTaskTypeInfo]: 'Information einsehen',
  [Resource_AppointmentTaskType.AppointmentTaskTypeDocumentDownload]: 'Datei herunterladen',
  [Resource_AppointmentTaskType.AppointmentTaskTypeDocumentUpload]: 'Datei hochladen',

  [Resource_AppointmentTaskDueStage.AppointmentTaskDueStageBeforeAppointment]: 'Vorab',
  [Resource_AppointmentTaskDueStage.AppointmentTaskDueStageDuringAppointment]: 'Während',
  [Resource_AppointmentTaskDueStage.AppointmentTaskDueStageAfterAppointment]: 'Nachträglich',

  'appointment.notes': 'Tagebucheinträge & Notizen',
  'appointment.note': 'Notiz',
  'appointment.edit-note': 'Notiz bearbeiten',
  'appointment.add-note': ' Notiz hinzufügen',
  'appointment.enter-note': 'Notiz eingeben',
  'appointment.delete-note.are-you-sure': 'Sind Sie sicher, dass Sie die Notiz löschen wollen?',
};
